import { Observable } from 'rxjs';
import { TpvUnitListItem, UnitCreatedResult } from '@app/domain/models/tpv/unit.model';
import { TpvUnitDetail } from '@app/domain/models/tpv/entity-detail.model';
import { CreateUnitRequest } from '@app/data/dtos/tpv/unit.dto';
import { UpdateUnitRequest } from '@app/data/dtos/tpv/company-update.dto';

/**
 * Port para el CRUD de unidades de negocio de una empresa (multi-unidad, §2).
 * Permiso backend: IsAdmin (o gestor TPV scoped por-Company).
 *
 * `idCompany` = PK ENTERO de la org (va en la ruta; el backend resuelve el UUID
 * de TPV). `idUnit` = UUID de la unidad. Las rutas viejas `/companies/<id>/unit/`
 * (singular) fueron ELIMINADAS por el backend → 404.
 */
export abstract class UnitRepository {
  /** Lista las unidades de una empresa. */
  abstract listUnits(idCompany: string): Observable<TpvUnitListItem[]>;

  /**
   * Detalle (passthrough live) de una unidad:
   * `GET /companies/<id_company>/units/<id_unit>/`. Identidad + dirección +
   * contacto + banco completos. Requiere AMBOS ids (UUID).
   */
  abstract getUnitById(idCompany: string, idUnit: string): Observable<TpvUnitDetail>;

  /** Crea una unidad ADICIONAL bajo la empresa. Devuelve el `id_unit` (UUID) creado. */
  abstract createUnit(idCompany: string, payload: CreateUnitRequest): Observable<UnitCreatedResult>;

  /** Edición parcial de una unidad (bloques unit/address/contact_person/bank). */
  abstract updateUnit(idCompany: string, idUnit: string, payload: UpdateUnitRequest): Observable<void>;

  /** Baja reversible (soft-delete) de una unidad. */
  abstract deleteUnit(idCompany: string, idUnit: string): Observable<void>;
}
